import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Fund} from "../models/fund";
import {FundApiService, FundMergePreview} from "../generated-sources/api";
import {CopyConfig} from "../models/copy-config";
import {FundData} from "../models/fund-data";
import {FundPage} from "../models/fund-page";
import {FundOverviewParams} from "../store/fund.state";

@Injectable({
    providedIn: "root"
})
export class FundService {
    private readonly fundApiService = inject(FundApiService);

    constructor() {
    }

    searchFunds(dataset: string | undefined, params: FundOverviewParams): Observable<FundPage> {
        return this.fundApiService.searchFunds(
            dataset,
            params.search || undefined,
            params.page,
            params.size,
            params.sort,
            params.isArchived
        );
    }

    getFunds(dataset?: string, isArchived?: boolean): Observable<Fund[]> {
        return this.fundApiService.getFunds(dataset, isArchived);
    }

    getFundData(fundId: number, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string): Observable<FundData> {
        return this.fundApiService.getFundData(fundId, fundReportId, fundValuationId, dealId, dataset)
    }

    createFund(fund: Fund, dataset?: string): Observable<Fund> {
        return this.fundApiService.createFund(fund, dataset);
    }

    updateFund(fundId: number, fund: Fund, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string): Observable<FundData> {
        console.log("updateFund")
        return this.fundApiService.updateFund(fundId, {
            fund,
            fundReportId,
            fundValuationId,
            dealId,
            dataset
        });
    }

    updateFundName(fundId: number, name: string): Observable<Fund> {
        return this.fundApiService.patchFund(fundId, {name});
    }

    archiveFund(fundId: number, archive: boolean): Observable<Fund> {
        return this.fundApiService.patchFund(fundId, {archive});
    }

    copyFundReportAndValuations(copyConfig: CopyConfig): Observable<number> {
        return this.fundApiService.copyFundReportAndValuations(copyConfig);
    }

    setMergeTarget(fundId: number, fundReportId?: number, mergeTargetId?: number, dataset?: string): Observable<FundData> {
        return this.fundApiService.setMergeTargetFund(fundId, fundReportId, mergeTargetId, dataset)
    }

    getMergePreview(fundId: number, dataset?: string): Observable<FundMergePreview> {
        return this.fundApiService.getFundMergePreview(fundId, dataset);
    }
}
